const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://ai-service-399822643074.asia-northeast1.run.app';

export const endpoints = {
  getReceptionAgentResponse: `${API_BASE_URL}/v1/getReceptionAgentResponse`,
  getTutorResponse: `${API_BASE_URL}/tutor-response`,
};